<template>
  <div class="service-category flex-col">
    <img class="category-icon" referrerpolicy="no-referrer" :src="serviceData.backBg" :style="{ width: serviceData.imgSize[0] }" />
    <div class="category-tag-wrapper flex-col">
      <span class="category-tag-text">{{ serviceData.name }}</span>
    </div>
    <span class="category-desc">{{ serviceData.value }}</span>

    <div class="feature-grid flex-row">
      <div class="feature-item flex-col" v-for="(item, index) in serviceData.serviceList" :key="index">
        <span class="feature-text">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  serviceData: {
    type: Object,
    required: true,
  },
})
</script>

<style lang="less" scoped>
.service-category {
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
  align-items: center;
}

.category-icon {
  align-self: center;
  margin-top: 50px;
  margin-bottom: 16px;
}

.category-tag-wrapper {
  background: linear-gradient(180deg, #9ab2ee 0%, #2c64fa 100%);
  border-radius: 50px;
  align-self: center;
  margin-top: 17px;
  padding: 0px 32px;

  .category-tag-text {
    color: #ffffff;
    font-size: 28px;
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-weight: normal;
    text-align: center;
    white-space: nowrap;
    line-height: 54px;
  }
}

.category-desc {
  width: 100%;
  color: #333333;
  font-size: 24px;
  font-family: AlibabaPuHuiTi_2_55_Regular;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 33px;
  align-self: center;
  margin-top: 16px;
}

.feature-grid {
  width: 600px;
  align-self: center;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  margin-top: 16px;
  margin-bottom: 16px;

  .feature-item {
    background-color: #ebf1fb;
    border-radius: 24px 24px 24px 0px;
    height: 48px;
    padding: 8px 32px;
    margin: 16px 0px;
    justify-content: center;
    align-items: center;

    .feature-text {
      color: #333333;
      font-size: 24px;
      font-family: AlibabaPuHuiTi_2_55_Regular;
      font-weight: normal;
      text-align: center;
      white-space: nowrap;
      line-height: 33px;
    }
  }
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.flex-row {
  display: flex;
  flex-direction: row;
}
</style>
